import { ReactNode, useEffect, useRef } from 'react';

export function TelegramLoginButton({
    botName,
    buttonSize,
    cornerRadius,
    requestAccess,
    usePic,
    dataOnauth,
    dataAuthUrl,
    lang,
    widgetVersion,
}: {
    botName: string,
    buttonSize?: "large" | "medium" | "small",
    cornerRadius?: string,
    requestAccess?: boolean,
    usePic?: boolean,
    dataOnauth: (user: any) => void,
    dataAuthUrl?: string,
    lang?: 'ru' | 'en',
    widgetVersion?: string,
}): ReactNode {
    const ref = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-widget.js?' + widgetVersion;
        script.setAttribute('data-telegram-login', botName);
        script.setAttribute('data-size', buttonSize || 'medium');
        if (cornerRadius !== undefined) {
            script.setAttribute('data-radius', cornerRadius);
        }
        if (requestAccess) {
            script.setAttribute('data-request-access', 'write');
        }
        if (usePic) {
            script.setAttribute('data-userpic', 'true');
        }
        script.setAttribute('data-lang', lang || 'en');
        if (dataAuthUrl !== undefined) {
            script.setAttribute('data-auth-url', dataAuthUrl);
        } else {
            script.setAttribute(
                'data-onauth',
                'TelegramLoginWidget.dataOnauth(user)',
            );
        }
        script.async = true;
        ref.current?.appendChild(script);
     
        // @ts-ignore
        window.TelegramLoginWidget = {
            dataOnauth: (user: any) => dataOnauth(user),
        };
        
    }, []);
    
    return (
        <div
            ref={ ref }
            style={{
                display: 'inline-block',
                // background: 'blue',
            }}
        />
    )
}